import { ComponentData } from './ComponentData';
import { DataCategory } from './DataCategory';
import { OperationalDayName } from './OperationalDayName';

export class HeaderData {

    private _parent: ComponentData;

    constructor(parent: ComponentData) {
        if (!parent) { throw new Error('parent is not set'); }

        this._parent = parent;
    }

    public get isFirstStageLoaded(): boolean {
        return this._parent.isFirstStageLoaded;
    }
    public get today(): OperationalDayName | null {
        return this._parent.operDays.length > 0
            ? this._parent.operDays[0].name
            : null;
    }
    public get selectedDataCategory(): DataCategory {
        return this._parent.selectedDataCategory;
    }

    public selectCategory(category: DataCategory): void {
        this._parent.selectCategory(category);
    }
}
